// removed by extract-text-webpack-plugin
module.exports = {"base":"_3GlAS","isPageLoader":"pQsrC","cell":"_2o7dO","icon":"_3gqx5","spin":"_1RJH7","inlineIcon":"_2lBu8","inline":"YC2J1"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Loading/Loading.scss
// module id = 2498
// module chunks = 0